export const getServiceCardColors = (percent: number) => {
  if (percent > 75)
    return {
      circleBaseColor: "#21652C33",
      circleGradientFrom: "#368D44",
      circleGradientTo: "#21652C",
      textColor: "#84FF97",
      effectColor:
        "radial-gradient(50% 122.83% at 50% 100%, rgba(54, 141, 68, 0.14) 0%, rgba(54, 141, 68, 0.00) 100%), linear-gradient(90deg, rgba(54, 141, 68, 0.08) 0%, rgba(33, 101, 44, 0.08) 100%)",
    };
  if (percent > 50)
    return {
      circleBaseColor: "#007FDB33",
      circleGradientFrom: "#007FDB",
      circleGradientTo: "#0164AC",
      textColor: "#30A8FF",
      effectColor:
        "radial-gradient(50% 122.83% at 50% 100%, rgba(0, 127, 219, 0.14) 0%, rgba(0, 127, 219, 0.00) 100%), linear-gradient(90deg, rgba(0, 127, 219, 0.08) 0%, rgba(1, 100, 172, 0.08) 100%)",
    };
  if (percent > 25)
    return {
      circleBaseColor: "#DA593A33",
      circleGradientFrom: "#FF9E58",
      circleGradientTo: "#DA593A",
      textColor: "#FF9E58",
      effectColor:
        "radial-gradient(50% 122.83% at 50% 100%, rgba(255, 121, 88, 0.14) 0%, rgba(255, 121, 88, 0.00) 100%), linear-gradient(90deg, rgba(255, 121, 88, 0.08) 0%, rgba(218, 89, 58, 0.08) 100%)",
    };
  return {
    circleBaseColor: "#AB292933",
    circleGradientFrom: "#E53F3F",
    circleGradientTo: "#AB2929",
    textColor: "#FF4E4E",
    effectColor:
      "radial-gradient(50% 122.83% at 50% 100%, rgba(255, 78, 78, 0.14) 0%, rgba(255, 78, 78, 0.00) 100%), linear-gradient(90deg, rgba(229, 63, 63, 0.08) 0%, rgba(171, 41, 41, 0.08) 100%)",
  };
};
